import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat,findArrayObject,isFunction,getRequestTimeInMillis } from '../../../../utils/utils';
import { Box } from '@material-ui/core';
import { JourneyTripBilty,JourneyTripPOD } from '../../../../components/icons';
import { Button } from '@material-ui/core';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import ImageUploadDialog from '../../../components/ImageComponent/ImageUploadDialog';
import { addNewPodDweb,deleteTripPod } from '../../../../store/actions/tripActionCreator';
import ImageViewDialog from '../../../components/ImageComponent/ImageViewDialog';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    padding:16,
    marginTop:16,
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    borderRadius: 8,
    border: 'solid 1px #ddd',
    boxShadow:'none',
    flexDirection:'column'
    //justifyContent:'space-between'
  },
  icon:{
    fontSize:52,
    color:'#000'
  },
  label:{
    color:'#0b1323',
    fontSize:18,
    fontWeight:600,
    marginLeft:16
  },
  labelImages:{
    color:'rgba(11, 19, 35, 0.75)',
    fontSize:12,
    fontWeight:600,
    marginLeft:12
  },
  value:{
    fontWeight:600,
    color:'#0b1323',
    fontSize:14,
    textAlign:'center'
  },
  viewPOD:{
    padding:'9px 24px',
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    color: '#03c',
    fontWeight: 600,
    borderRadius: 4,
    fontSize:14,
    border: 'solid 1px #03c',
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  addPODButton:{
    padding:'10px 12px',
    backgroundColor: '#03c',
    textTransform: 'capitalize',
    color: '#fff',
    fontWeight: 600,
    borderRadius: 4,
    fontSize:12,
    //border: 'solid 1px #00875a',
    '&:hover': {
      backgroundColor: '#03c'
    }
  }
}));
const JourneyTripCreateViewPODCard = (props) => {
  const {selectedTrip,journey,updateJourney,dispatchAddNewPod,dispatchDeleteTripPod} = props;
  const classes = useStyles();
  let history = useHistory();
  let tripId =selectedTrip && selectedTrip.id?selectedTrip.id:'';
  let selectedPOD = findArrayObject('tripId',tripId, journey && journey.pods?journey.pods:[]);
  const [imagesViewerOpen, setImagesViewerOpen] = React.useState(false);
  const [imagesUploaderOpen, setImagesUploaderOpen] = React.useState(false);
  const [images, setImages] = React.useState([]);

  const handleImagesUploaderClose = ()=>{
    setImagesUploaderOpen(false);
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleImagesViewerClose = ()=>{
    setImagesViewerOpen(false);
    fetchTripDetails()
  }
  const handleImagesViewerConfirm= ()=>{
    setImagesViewerOpen(false);
    fetchTripDetails()
  }
  const handleImagesViewerOpen = ()=>{
    setImages(selectedPOD && selectedPOD.list? selectedPOD.list.filter((pod)=>pod&&pod.id&&pod.podLink):[]);
    setImagesViewerOpen(true);
  }
  const fetchTripDetails = ()=>{
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  } 
   const handleImagesUploaderConfirm= (images)=>{
    if (images.length>0) {
        let newPodRequest = {
          podImageS3Links: images,
          podReceivedDate: getRequestTimeInMillis(new Date())
        }
        dispatchAddNewPod(tripId, newPodRequest, ()=>{
            setImagesUploaderOpen(false);
            fetchTripDetails()
        }, null);
    }else{
      setImagesUploaderOpen(false);
    }
  }
  const getImages = (images)=>{
    let steps =[];
    if (images && Array.isArray(images)) {
        for (const key in images) {
          if (Object.hasOwnProperty.call(images, key)) {
            const element = images[key];
            let image={
              label:'',
              imgPath:null
            }
            if (element && Object.hasOwnProperty.call(element, 'podLink')&& element.id && element.podLink) {
              image.label='POD Image'
              image.imgPath=element.podLink;
            }
            if (Object.hasOwnProperty.call(element, 's3Link') && element.id && element.s3Link) {
              image.label='LR/GCN Image'
              image.imgPath=element.s3Link;
            }
            steps.push({...image,...element});
          }
        }
        return steps;
    }
    return[];
  }
  const onPODDelte = (pod)=>{
    if(pod && pod.id){
      dispatchDeleteTripPod(tripId, pod.id,
        () => {
          setImagesViewerOpen(false);
          fetchTripDetails()
        }, null);
    }
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
        <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
          <Box display={'flex'} alignItems={'center'}>
            <JourneyTripPOD />
            <Typography className={classes.label}>POD Challan</Typography>
          </Box>
          {!selectedPOD?<Button variant='contained' onClick={()=>{setImagesUploaderOpen(true)}} className={classes.addPODButton} ><AddAPhotoIcon  style={{fontSize:16}} />&nbsp;Add POD</Button>
          :<Button onClick={handleImagesViewerOpen} variant='outlined' className={classes.viewPOD} >View POD</Button>}
        </Box>
        {selectedPOD&&<Box marginTop={'16px'} width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
          <Box display={'flex'} alignItems={'center'}>
            {selectedPOD && selectedPOD.list && selectedPOD.list && selectedPOD.list.filter((pod)=>pod&&pod.id&&pod.podLink).map((pod,index)=>{
              return index ===0?<img style={{borderRadius:4}} width={'32px'} height='32px' src={pod.podLink}></img>:null
            })}
            {selectedPOD && selectedPOD.list && selectedPOD.list.filter((pod)=>pod&&pod.id&&pod.podLink).length > 1 && <Typography className={classes.labelImages}>+{selectedPOD.list.filter((pod)=>pod&&pod.id&&pod.podLink).length-1} more images</Typography>}
          </Box>
          <Box padding={'8px'} borderRadius={'4px'} border={'solid 1px #ebebeb'} style={{cursor:'pointer'}}>
            <AddAPhotoIcon onClick={()=>{setImagesUploaderOpen(true)}} style={{fontSize:16,color:'#03c'}} />
          </Box>
        </Box>}
      </Paper>
      {imagesUploaderOpen && <ImageUploadDialog header={'Upload POD Image'} multiple={true} uploadText={'Upload POD'} open={imagesUploaderOpen} onClose={handleImagesUploaderClose} onConfirm={handleImagesUploaderConfirm} />}
      {imagesViewerOpen && <ImageViewDialog deleteEnable={true} onDelete={onPODDelte} thumb={true} label={false} selectedTrip={selectedTrip} journey={journey} updateJourney={updateJourney} images={getImages(images)} active={0} header={'POD Images'} open={imagesViewerOpen} onClose={handleImagesViewerClose} onConfirm={handleImagesViewerConfirm} />}
    </>
  );
}
const JourneyTripCreateViewPODCardWithRouter = withRouter(JourneyTripCreateViewPODCard);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddNewPod: (tripId, data, onSuccess, onFailure) => { dispatch(addNewPodDweb(tripId, data, onSuccess, onFailure)) },
  dispatchDeleteTripPod: (tripId, podId, onSuccess, onFailure) => { dispatch(deleteTripPod(tripId, podId, null, onSuccess, onFailure)) },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyTripCreateViewPODCardWithRouter);